<mat-form-field [appearance]="appearance" [floatLabel]="floatLabel">
  @if (label) {
    <mat-label>{{label}}</mat-label>
  }
  <mat-select
    multiple
    [formControl]="control"
    panelClass="filter-select-panel"
    [matTooltip]="selectedLabels().length > 1 ? selectedLabels().join(', ') : ''"
    [matTooltipClass]="'field-tooltip'"
    [matTooltipPosition]="tooltipPosition"
    (closed)="onClosed()">
    <mat-select-trigger>{{ summary() }}</mat-select-trigger>

    @for (option of options; track option.value) {
      <mat-option
        [value]="option.value"
        [class.filter-multi-select__option--locked]="isLocked(option)"
        [matTooltip]="isLocked(option) ? 'At least one option is required' : ''"
        [matTooltipClass]="'app-tooltip'"
        [matTooltipPosition]="'right'">
        {{option.label}}
      </mat-option>
    }
  </mat-select>
</mat-form-field>
